import React from "react";
import "./ItemPickerDD.css";
import { getAllItems } from '../service/ItemService';

class ItemPickerDD2 extends React.Component {
  constructor(props) {
    super(props);

    // @defaultSelectText => Show default text in select
    // @showOptionList => Show / Hide List options
    // @optionsList => List of options
    this.state = {
      defaultSelectText: "test",
      showOptionList: false,
      optionsList: [],
      hover:false,
      items: [],
      selectedItem: {color: '#444'},
      selectedColor: 'white'
    };
  }

  componentDidMount() {
    // Add Event Listner to handle the click that happens outside
    // the Custom Select Container
    document.addEventListener("mousedown", this.handleClickOutside);
    this.setState({
      defaultSelectText: this.props.defaultText
    });
    let defaultItem = {id: 0, name: "Minden kísérlet", color: '444'};
    if(this.props.items){
        this.setState({items: [...this.props.items]});
    }
    else{
        getAllItems().then(data => {
            if((this.props.allItemsOption))
              this.setState({items: [defaultItem, ...data]});
            else 
              this.setState({items: data});
        });
    }
  }

  componentWillUnmount() {
    // Remove the event listner on component unmounting
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  // This method handles the click that happens outside the
  // select text and list area
  handleClickOutside = e => {
    if (!e.target.classList.contains("kwizda-itempicker-option") &&
      !e.target.classList.contains("kwizda-itempicker-selected-text")) {
      this.setState({
        showOptionList: false
      });
    }
  };

  // This method handles the display of option list
  handleListDisplay = () => {
    this.setState(prevState => {
      return {
        showOptionList: !prevState.showOptionList
      };
    });
  };

  // This method handles the setting of name in select text area
  // and list display on selection
  handleOptionClick = e => {
    let selectedId = e.target.getAttribute("data-id");
    this.setState({
      defaultSelectText: e.target.getAttribute("data-name"),
      selectedColor: e.target.getAttribute("data-color"),
      showOptionList: false
    });
    //this.props.onChange(e.target.getAttribute("data-name"));

    let itemid = selectedId;
    let item = this.state.items.find(i=>i.id === itemid);
    this.setState({selectedItem:item});
    this.props.itemSelected(itemid); 
  }

  render() {
    const { showOptionList, defaultSelectText } = this.state;
    return (
      <div className={"kwizda-itempicker-container"} style={(this.props.floatLeft)?{float:'left'}:{float:'none'}}>
        <div onMouseEnter={()=> this.setState({hover:true})} onMouseLeave={()=> this.setState({hover:false})}
          className={"kwizda-itempicker-selected-text kwizda-item-color-" + this.state.selectedColor.replace("#","")}
          onClick={this.handleListDisplay}
        >
          <div>{defaultSelectText}</div>
          {(this.state.hover || showOptionList)?
          <div className="kwizda-itempicker-select-hover"></div>
          :
          <div className="kwizda-itempicker-select-nohover"></div>
          }
        </div>
        {showOptionList && (
          <ul className="kwizda-itempicker-options">
            {this.state.items && this.state.items.map((itemObj, i)=> {
                return (
                    <li 
                    className={"kwizda-itempicker-option kwizda-item-color-" + itemObj.color.replace("#","")}
                    data-id={itemObj.id}
                    data-name={itemObj.name}
                    data-color={itemObj.color}
                    key={"option" + i}
                    onClick={this.handleOptionClick}
                    >
                    {itemObj.name} ({itemObj.id})
                    </li>
                );
                })
            }
          </ul>
        )}
      </div>
    );
  }
}

export default ItemPickerDD2;
